import AboutSection from "../../component/modules/aboutSection/AboutSection";
import AppHeader from "../../component/modules/appHeader/AppHeader";
import ContactSection from "../../component/modules/contactSection/ContactSection";
import Footer from "../../component/modules/footer/Footer";
import HomeSection from "../../component/modules/homeSection/HomeSection";
import OurServicesSection from "../../component/modules/ourServicesSection/OurServicesSection";
import PortfolioSection from "../../component/modules/portfolioSection/PortfolioSection";
import { PORTFOLIO_SECTION } from "../../utility/utilityData";
import "./index.css";

const HomePage = () => {
  return (
    <div className="home_page_container">
      <AppHeader />
      <div className="home_content_container">
        {/* ---------------------HOME SECTION------------------ */}
        <HomeSection />
        {/* ---------------------OUR SERVICES SECTION------------------ */}
        <OurServicesSection isHomePage style={{ backgroundColor: "#fbfafa" }} />
        {/* ---------------------PORTFOLIO SECTION------------------ */}
        <PortfolioSection
          sectionHeading={PORTFOLIO_SECTION?.sectionHeading || ""}
          headingPart1={PORTFOLIO_SECTION?.headingPart1 || ""}
          headingPart2={PORTFOLIO_SECTION?.headingPart2 || ""}
          description={PORTFOLIO_SECTION?.description}
          portfolio={PORTFOLIO_SECTION?.portfolio}
          isHomePage
        />
        {/* ---------------------ABOUT SECTION------------------ */}
        <AboutSection style={{ backgroundColor: "#fbfafa" }} isHomePage />
        {/* ---------------------CONTACT SECTION------------------ */}
        <ContactSection isHomepage />
      </div>
      {/* ---------------------FOOTER SECTION------------------ */}
      <Footer />
    </div>
  );
};

export default HomePage;
